export const en = {
    noticeMessageSuccess: {
        one: '{count} ad group copied to the selected campaigns',
        some: '{count} ad groups copied to the selected campaigns',
        many: '{count} ad groups copied to the selected campaigns',
        none: '{count} ad groups copied to the selected campaigns'
    },
    noticeMessageSuccessOneCampaign: {
        one: '{count} ad group copied to campaign No. {campaignId}',
        some: '{count} ad groups copied to campaign No. {campaignId}',
        many: '{count} ad groups copied to campaign No. {campaignId}',
        none: '{count} ad groups copied to campaign No. {campaignId}'
    },
    noticeSingleGroupNoticeMessage: 'Ad group No. {id} copied to the selected campaigns',
    noticeSingleGroupSingleCampaignMessage: 'Ad group No. {id} copied to campaign # {campaignId}'
};
